export default {
  WOOTRIC_ACCOUNT_TOKEN: "NPS-209b5087", // This is your unique account token.
  WOOTRIC_SURVEY_IMMEDIATELY: false, // Shows survey immediately for testing purposes.  TODO: Comment out for production.
  WOOTRIC_NO_SURVEYED_COOKIE: false, // Bypass cookie based throttle for testing purposes.  TODO: Comment out for production.
};
